module.exports = __webpack_public_path__ + "img/hr-tree-05-h-trunk.de55111f.png";